module.exports = __webpack_public_path__ + "hat-twilight-neon.371cc2063859eb929b7c.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/hat-twilight-neon.svg
// module id = ../../../../../src/assets/img/hat-twilight-neon.svg
// module chunks = main